import { createSlice } from "@reduxjs/toolkit";
import { mainExtraReducers } from "./mainExtraReducers";
import { mainReducers } from "./mainReducers";

const initialState = {
  stewards: [],
  liveStockType: null,
  pending: false,
  poultryScienceData: [],
};
const slice = createSlice({
  name: "main",
  initialState,
  extraReducers: mainExtraReducers,
  filteredStewardsData: [],
  filterState: false,
  reducers: mainReducers,
  filterType: "showAll",
});

export const { reducer: mainSlice } = slice;

export const {
  SET_FILTER_STATE,
  SET_FILTERED_STEWARDS,
  SET_FILTER_TYPE,
  SET_LIVESTOCK_TYPE,
} = slice.actions;
